import { useState } from 'react';

import { types } from './shared';
import { useAppContext } from '../../shared';
import { Button, SubmitButton } from '../../components';
import { Modal, Form, FormItem } from '../../components';
import { Input, Dropdown, Toggle } from '../../components';
import type { FormType } from './usePrompts';

type PromptModalProps = {
  values?: FormType;
  loading: boolean;

  onSumbit?: (values: FormType) => void;
  onClose: () => void;
};

export const PromptModal: React.FC<PromptModalProps> = ({
  loading,
  values,
  onSumbit,
  onClose,
}) => {
  const { meta } = useAppContext();
  const [item, handleChange] = useState<FormType>(
    values || { is_active: 'true' }
  );

  return (
    <Form initialValue={item} onChange={handleChange}>
      <Modal
        open
        size="big"
        title={values ? 'Edit Prompt' : 'Add Prompt'}
        onClose={onClose}
        headerActions={
          <>
            <SubmitButton
              label="Save"
              type="primary"
              loading={loading}
              onClick={() => item && onSumbit?.(item)}
            />
            <Button onClick={onClose}>Cancel</Button>
          </>
        }
      >
        <div className="flex flex-col gap-y-md">
          <FormItem<NonNullable<typeof item>> name="name" label="Name" required>
            <Input />
          </FormItem>
          <FormItem<NonNullable<typeof item>>
            label="Campaign"
            name="campaign_id"
            required
          >
            <Dropdown options={meta.campaigns} />
          </FormItem>
          <FormItem<NonNullable<typeof item>>
            name="prompt_type"
            label="Type"
            required
          >
            <Dropdown options={types} />
          </FormItem>
          <FormItem<NonNullable<typeof item>>
            name="description"
            label="Description"
            required
          >
            <Input />
          </FormItem>
          <FormItem<NonNullable<typeof item>>
            name="content"
            label="Content"
            required
          >
            <Input multiline rows={16} />
          </FormItem>
          <FormItem<NonNullable<typeof item>>
            name="version"
            label="Version"
            required
          >
            <Input />
          </FormItem>
          <FormItem<NonNullable<typeof item>>
            name="is_active"
            label="Active"
            required
          >
            <Toggle />
          </FormItem>
        </div>
      </Modal>
    </Form>
  );
};
